import React, { FC } from 'react';
import { SidebarSortingFilters } from '../SortingFilter/types/sortingFilters';
import { SortingFilter } from '../SortingFilter/SortingFilter';

interface SortingFilterContainerProps {
  isModal?: boolean;
  allPoolsFilters: SidebarSortingFilters;
  setAllPoolsFilters: (filters: SidebarSortingFilters) => void;
  searchValue?: string;
  setSearchValue?: (searchValue: string) => void;
  setIsFiltersOpen?: (isFiltersOpen: boolean) => void;
}

const SortingFilterContainer: FC<SortingFilterContainerProps> = ({
  isModal,
  allPoolsFilters,
  setAllPoolsFilters,
  searchValue = '',
  setSearchValue = () => {},
  setIsFiltersOpen = () => {},
}) => {
  return (
    <div className="">
      <SortingFilter
        isModal={isModal}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setIsFiltersOpen={setIsFiltersOpen}
        onChange={(updatedFilters: SidebarSortingFilters) => setAllPoolsFilters(updatedFilters)}
        filters={allPoolsFilters}
      />
    </div>
  );
};

export default SortingFilterContainer;
